import { formatDate } from 'helpers/formatters/date_time_formats';
import { post } from 'helpers/api';
import { pluralize } from 'helpers/formatters/string_formats';

export function getRelativeDateLabel(reminder) {
  if (reminder.sendOn.static) {
    return formatDate(reminder.sendOn.date);
  } else {
    return `${pluralize(reminder.sendOn.modifier, reminder.sendOn.units)} ${reminder.sendOn.operator}`;
  }
}

export async function checkDateChangeForImmediateReminders(path, date, reminders) {
  if (path) {
    return await post(path, {
      ...date,
      ignoredReminderIds: reminders.filter(reminder => reminder._destroy).map(reminder => reminder.id),
    });
  } else {
    return { reminders: [], users: [] };
  }
}
